import FetchData from '@shared/utils/fetchData/fetchData';

import { PersonalAccountAddressInfoType, PersonalAccountInfoResponseType } from '../../';

export const addAddressInfo = async (info: PersonalAccountAddressInfoType) => {
  return await FetchData.patch<PersonalAccountInfoResponseType>('v2/user/address', {
    body: JSON.stringify(info)
  });
};
